import {
  Component,
  computed,
  ElementRef,
  inject,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { ActiveTenantMenuComponent } from './active-tenant-menu/active-tenant-menu.component';
import { LayoutService } from 'src/app/shared/services/layout.service';
import { UserStore } from 'src/app/shared/user/store/user.store';

@Component({
  selector: '[app-sidebar]',
  standalone: true,
  imports: [
    CommonModule,
    UserMenuComponent,
    MainMenuComponent,
    ActiveTenantMenuComponent,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css',
})
export class SidebarComponent {
  @ViewChild('menuContainer') menuContainer!: ElementRef;
  timeout: any = null;
  private readonly router = inject(Router);
  public readonly userStore = inject(UserStore);
  public layoutService = inject(LayoutService);
  public el = inject(ElementRef);

  isHorizontal = computed(() => this.layoutService.isHorizontal());
  isDarkTheme = computed(() => this.layoutService.isDarkTheme());

    isCompactMode = computed(
    () => this.layoutService.layoutConfig().menuMode === 'compact'
  );

  onMouseEnter() {
    if (!this.layoutService.layoutState().anchored) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.layoutService.layoutState.update((state) => {
        if (!state.sidebarActive) {
          return {
            ...state,
            sidebarActive: true,
          };
        }
        return state;
      });
    }
  }

  onMouseLeave() {
    if (!this.layoutService.layoutState().anchored) {
      if (!this.timeout) {
        this.timeout = setTimeout(() => {
          this.layoutService.layoutState.update((state) => {
            if (state.sidebarActive) {
              return {
                ...state,
                sidebarActive: false,
              };
            }
            return state;
          });
        }, 300);
      }
    }
  }

  anchor() {
    this.layoutService.layoutState.update((state) => ({
      ...state,
      anchored: !state.anchored,
    }));
  }

  changeMenuLayout() {
     const wasCompact = this.layoutService.layoutConfig().menuMode === 'compact';

  this.layoutService.layoutConfig.update((state) => ({
    ...state,
    menuMode: state.menuMode === 'compact' ? 'static' : 'compact',
  }));

  const isCompactNow = this.layoutService.layoutConfig().menuMode === 'compact';

  // Nur wenn gerade auf compact gewechselt wurde
  if (!wasCompact && isCompactNow) {
    this.layoutService.reset();
  }
  }

  hoverGapToggle = false;

onGapMouseEnter() {
  this.hoverGapToggle = true;
}

onGapMouseLeave() {
  this.hoverGapToggle = false;
}

navigateWelcomeDashboard() {
  this.router.navigate(['/dashboard/welcome']);
}
}
